export default __webpack_public_path__ + "static/media/webdev2.d672408b.svg";